import React, { Component } from "react";
import MainLogin from "../../config/mainLogin";
import swal from "sweetalert";
import { validateLogin } from '../../dummy-data/credentials';

export default class Login extends Component {
  state = {
    user_name: '',
    user_password: '',
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleLogin = async (event) => {
    event.preventDefault()
    document.getElementById('btnLogin').disabled = true
    document.getElementById('btnLogin').innerHTML = 'wait&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i>'

    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 800));

    const result = validateLogin(this.state.user_name, this.state.user_password);

    if (result.success) {
      // Login berhasil - simpan data ke localStorage
      const userData = result.data;
      localStorage.setItem("un", userData.user_data.usid);
      localStorage.setItem("adm", userData.level_id);
      localStorage.setItem("nama", userData.user_data.user_nama);
      localStorage.setItem("role", userData.role);
      localStorage.setItem("grub_id", userData.grub_id);
      localStorage.setItem("user_data", JSON.stringify(userData.user_data));

      swal({
        icon: "success",
        title: "Login Berhasil!",
        text: `Selamat datang, ${userData.user_data.user_nama}`,
        timer: 1500,
        buttons: false,
      }).then(() => {
        window.location.replace('/home');
      });
    } else {
      swal({
        icon: "error",
        title: "Gagal Login!",
        text: "Username atau password salah!\n\nGunakan salah satu akun demo:\n• admin.akademik / demo@akademik2024\n• admin.prodi / demo@prodi2024\n• dosen / demo@dosen2024"
      });
      document.getElementById('btnLogin').disabled = false
      document.getElementById('btnLogin').innerHTML = "Login"
    }
  }

  componentDidMount = () => {
    if (localStorage.getItem('isLogin')) {
      window.location.replace('/home')
    } else {
      setTimeout(function () {
        document.getElementById("darkLoader").classList.add("sembunyi")
        document.getElementById("loginArea").classList.remove("sembunyi")
      }, 2000)
    }
  };

  render() {
    return (
      <div>
        {localStorage.getItem('isLogin') ? null :
          <>
            <MainLogin />
            <div id="loginArea" className="sembunyi">
              <div className="content" id="animasi">
                <div className="container centerVer">
                  <div className="row">
                    <div className="col-md-6 order-md-2 mb-3" id="gbrLog">
                      <img
                        src="loginAset/images/gambar.svg"
                        alt="Image"
                        className="img-fluid"
                        style={{ width: '100%', marginTop: '2%' }}
                        id="gbrku"
                      />
                    </div>
                    <div className="col-md-6 contents">
                      <div className="row justify-content-center">
                        <div className="col-md-8">
                          <img
                            src="adminAset/images/logo.png"
                            style={{ width: '48%', marginBottom: '6%' }}
                            alt="Logo"
                          />
                          <div className="mb-4">
                            <h3 style={{ lineHeight: '1.2' }}>
                              Sistem Akademik <strong>Demo Portfolio</strong>
                            </h3>
                            <p className="mb-2 captionP">
                              Silahkan masuk untuk mengakses aplikasi.
                            </p>
                          </div>
                          <form onSubmit={this.handleLogin}>
                            <div className="form-group first" style={{ marginTop: '30px' }}>
                              <label htmlFor="username">Username</label>
                              <input
                                type="text"
                                className="form-control"
                                onChange={this.handleChange}
                                name="user_name"
                                id="user_name"
                                style={{ fontSize: '16px' }}
                                placeholder="Masukkan username"
                              />
                            </div>
                            <div
                              className="form-group last mb-4"
                              style={{ marginTop: "35px" }}
                            >
                              <label htmlFor="password">Password</label>
                              <input
                                type="password"
                                className="form-control"
                                id="user_password"
                                onChange={this.handleChange}
                                name="user_password"
                                style={{ fontSize: '16px', marginBottom: '-10px' }}
                                placeholder="Masukkan password"
                              />
                            </div>

                            {/* Demo Credentials Info */}
                            <div className="alert alert-info" style={{ fontSize: '12px', padding: '10px', marginBottom: '15px' }}>
                              <strong>Demo Account:</strong><br />
                              <table style={{ fontSize: '11px', marginTop: '5px' }}>
                                <tbody>
                                  <tr>
                                    <td><strong>Admin Akademik:</strong></td>
                                    <td style={{ paddingLeft: '5px' }}>admin.akademik / demo@akademik2024</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Admin Prodi:</strong></td>
                                    <td style={{ paddingLeft: '5px' }}>admin.prodi / demo@prodi2024</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Dosen:</strong></td>
                                    <td style={{ paddingLeft: '5px' }}>dosen / demo@dosen2024</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            {/* button login  */}
                            <button
                              style={{ marginTop: "15px" }}
                              type="submit"
                              className="btn text-white btn-block btn-primary2"
                              id="btnLogin">
                              Login
                            </button>
                            {/* end button login  */}
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <svg id="darkLoader" className="" width="100%" viewBox="0 0 100 100" style={{ backgroundColor: 'white' }}>
              <circle className="circle" id="circle-1" cx={50} cy={50} r={1000} fill="rgba(167, 206, 232, .25)" />
              <circle className="circle" id="circle-2" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
              <circle className="circle" id="circle-3" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
            </svg>
          </>
        }
      </div>
    );
  }
}
